<template>
  <div class="emb-subscribe-wrap section-gap" style="padding:10px">
    <v-container grid-list-xl py-0>
      <v-layout row wrap align-center justify-space-between>
        <v-flex xs12 sm12 md8 lg8 xl8>
          <div class="subscribe-content">
            <div>
              <h3 class="white--text">{{data.Title}}</h3>
              <p class="white--text">{{data.Description}}</p>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm12 md4 lg3 xl2>
          <div class="form-wrapper">
            <v-text-field
              dark
              color="white"
              class="mt-0 pt-0"
              v-model="email"
              :label="data.Email_Placeholder"
              required
            ></v-text-field>
            <a heref="javascript:void(0)" class="send-icon">
              <i class="material-icons white--text" v-on:click="subscribeNewsletter">send</i>
            </a>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import gettingRestClientObject from "../../../services/utils/cms-helper";
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment
});
export default {
  props: ["data"],
  data() {
    return {
      email: "",
      emailRules: [v => /.+@.+/.test(v) || "E-mail must be valid"],

      cmsRequestFunctions: null,
      subscribeSection: ""
    };
  },
  methods: {
    subscribeNewsletter: async function() {
      if (!this.email) {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M007"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      var emailPat = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      var matchArray = this.email.match(emailPat);
      if (matchArray == null) {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M010"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      } else {
        var filterValue = "type='Newsletter' AND keyword1='" + this.email + "'";
        var allData = await this.cmsRequestFunctions.getDbDataTableValue(
          filterValue,
          "date1"
        );
        if (allData != undefined && allData.data != undefined) {
          this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M036"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        } else {
          var requestedDate = moment(String(new Date())).format(
            "YYYY-MM-DDThh:mm:ss"
          );
          var user=  localStorage.getItem('embryo');
       var userData=JSON.parse(user);
        var loginDetails=userData.user_data;
        var userName=loginDetails.loginId;
        var newsletterName;
        if(loginDetails==''){
       userName="Guest User";

        }
          var insertNewsletter = {
            type: "Newsletter",
            keyword2: userName,
            keyword: newsletterName,
            keyword1: this.email,
            date1: requestedDate
          };
          var resp = await this.cmsRequestFunctions.cmsFormData(
            insertNewsletter
          );
          if (resp != undefined) {
            this.email = "";
             this.$snotify.success(
          this.cmsRequestFunctions.getValidationMsgByCode("M037"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
          } else {
            console.log("Error", resp);
          }
        }
      }
    }
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
  }
};
</script>

